import { create } from "zustand";

// Tracks CCAvenue payments whose modal was dismissed (explicit cancel or the
// foreground wait window elapsing) before a final Success/Failure was known.
// cw-auth's ccavenue_transactions table remains the source of truth — this is
// just what lets POS keep watching for the outcome after the operator moves on.
const useCCAvenuePendingStore = create((set) => ({
  pending: [],

  addPending: (entry) =>
    set((state) => ({
      pending: [...state.pending.filter((p) => p.orderId !== entry.orderId), entry],
    })),

  removePending: (orderId) =>
    set((state) => ({
      pending: state.pending.filter((p) => p.orderId !== orderId),
    })),
}));

export default useCCAvenuePendingStore;
